import { render, staticRenderFns } from "./DocumentTypeEditor.vue?vue&type=template&id=68b7255c&scoped=true"
import script from "./DocumentTypeEditor.vue?vue&type=script&lang=js"
export * from "./DocumentTypeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b7255c",
  null
  
)

export default component.exports